/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { NoteDialogComponent } from './note-dialog.component';
import { NotesService } from '../../../core/services/notes/notes.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Injectable({
    providedIn: 'root'
})
export class NoteDialogService {
    onNewAssociationClicked = new BehaviorSubject(false);
    onSubmitClicked = new Subject();
    isNoteUpdated: Subject<boolean> = new Subject<boolean>();

    constructor(
        private zuperDialogService: ZuperDialogService,
        private toast: HotToastService,
        private notesService: NotesService,
        private utilityService: UtilityService,
        private dataCollectorService: DataCollectorService) {
        //Note Dialog component constructor
    }

    getUploadAttachmentModel(attachments: any[]): any[] {
        const uploaderAttachments: any[] = [];
        attachments.forEach((attachment: any) => {
            uploaderAttachments.push({
                attachment_path: attachment.attachment,
                attachment_name: attachment.attachment_name,
                attachment_size: attachment.attachment_size,
                ...(attachment.attachment_uid ? { attachment_uid: attachment.attachment_uid } : {})
            });
        });
        return uploaderAttachments;
    }

    createNewNote(moduleName: string, moduleUID: string, dataUrl: string, defaultAssociatedModuleDetails: any): void {
        const hideModuleAssociation: boolean = ['INVOICE', 'ESTIMATE'].includes(moduleName);
        const newNoteDialog: MatDialogRef<NoteDialogComponent> = this.zuperDialogService.openCustom(NoteDialogComponent,
            {
                extraClass: 'note-dialog-file-uploader',
                data: {
                    header: {
                        titleDisplayKey: 'create.note.text',
                        titleDisplayName: 'Create Note'
                    },
                    footer: {
                        submitDisplayKey: 'text.post_note',
                        submitDisplayName: 'Post Note',
                        closeDisplayKey: 'close.text',
                        closeDisplayName: 'Close'
                    },
                    config: {
                        editorOptions: {
                            isEnabled: true,
                            isTextArea: false,
                            options: {
                                placeholder: this.utilityService.getLocaleValue('notes.panel.editor.placeholder')
                            }
                        },
                        uploaderOptions: {
                            isEnabled: false
                        },
                        enablePrivacy: !hideModuleAssociation
                    },
                    hideModuleAssociation: hideModuleAssociation,
                    defaultAssociatedModule: moduleName,
                    defaultAssociatedModuleDetails: defaultAssociatedModuleDetails
                }
            });
        newNoteDialog.disableClose = true;
        const onSubmitClicked: any = this.onSubmitClicked.subscribe((response: any) => {
            newNoteDialog.close(response);
        });
        newNoteDialog.afterClosed().subscribe((result: any) => {
            onSubmitClicked.unsubscribe();
            if (result) {
                if (['INVOICE', 'ESTIMATE'].includes(moduleName)) {
                    // // const uid = ParamKey[moduleName];
                    // const model = {
                    //     note: {
                    //         attachments: [],
                    //         is_private: false,
                    //         note: result.note,
                    //         note_type: AttachmentType.TEXT,
                    //         user_mentions: []
                    //     },
                    //     notify_users: true
                    // };
                    // // model.note[uid] = moduleUID;
                    // if(!_.isEmpty(result.associatedModules)){
                    //     _.each(_.keys(result.associatedModules), (module: string)=>{
                    //         if(module){
                    //             model.note[ParamKey[module.toUpperCase()]] = result.associatedModules[module]?.length > 0 ? result.associatedModules[module][0][ModuleUidKey[module.toUpperCase()]] : null;
                    //         }
                    //     });
                    // }
                    const payLoad: any = {
                        data: {
                            notes: [{
                                content: result.note || ''
                            }],
                            type: 'NOTE'
                        },
                        module_name: moduleName,
                        module_uid: moduleUID
                    };
                    this.postData(this.notesService.noteAttachmentUrl, payLoad);
                }
            }
        });
    }

    postData(dataUrl: string, payload: any): void {
        this.dataCollectorService.postData(dataUrl, payload).subscribe(
            (response: any) => {
                this.isNoteUpdated.next(true);
                this.toast.success(response.message);
            });
    }

}
